import { InjectionToken } from "@angular/core";
import { ShoppingCartDto } from "projects/shared/lib/services/INTEGRA_Shop_Client";

export abstract class ICartCreationDialogService
{

  abstract cartCreationDialogShow(
    callbackCancel?: () => void,
    cart?: ShoppingCartDto | undefined,
    isCartCreation?: boolean | undefined,
  ): void;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ICartCreationDialogServiceToken = new InjectionToken<ICartCreationDialogService>('ICartCreationDialogServiceToken');
